import { useMemo } from 'react';
import getConfig from 'next/config';
import { Hex } from 'viem';
import { useWalletContext } from '@/contexts/WalletContext';

const { publicRuntimeConfig } = getConfig();

export function blockExplorerUrlForL1Transaction(txHash: string) {
  return `${publicRuntimeConfig.l1ExplorerURL}/tx/${txHash}`;
}

export function blockExplorerUrlForL2Transaction(txHash: string) {
  return `${publicRuntimeConfig.l2ExplorerURL}/tx/${txHash}`;
}

export function useBlockExplorerURL(chainId: number, txHash?: Hex) {
  const { chains } = useWalletContext();
  return useMemo(() => {
    const chain = chains.find((chain) => chain.id === chainId);
    const explorerUrl = chain?.blockExplorers?.default.url;
    return `${explorerUrl}/tx/${txHash}`;
  }, [chainId, chains, txHash]);
}
